import { logger } from '../../../../logger';
import { Employee } from '../interfaces/interface';

export interface NameMatch {
  inputName: string;
  matches: Employee[];
  selectedEmployee?: Employee;
  manualEmail?: string;
  status: 'exact' | 'fuzzy' | 'multiple' | 'notfound' | 'manual';
}

export interface NameResolutionResult {
  requiredMembers: NameMatch[];
  optionalMembers: NameMatch[];
}

class NameResolver {
  private createEmployeeObject(emp: any): Employee {
    return {
      login_name: emp.login_name,
      employee_name: emp.employee_name,
      employee_internal_email_address: emp.employee_internal_email_address,
      job_title_name: emp.job_title_name,
      location_city_name: emp.location_city_name,
      location_state_name: emp.location_state_name,
      job_level_name: emp.job_level_name,
      employee_assistant_employee_id: emp.employee_assistant_employee_id,
      emplid: emp.emplid,
      displayName: emp.employee_name,
      department_name_current: emp.department_name_current,
      badgeColor: emp.badgeColor,
      timezone: emp.timezone,
      timeZoneId: emp.timeZoneId
    };
  }

  public findMatchesWithEmployeeData(inputName: string, employeeData: any[]): NameMatch {
    const trimmedName = inputName.trim();

    if (!trimmedName) {
      return {
        inputName,
        matches: [],
        status: 'notfound'
      };
    }

    if (!employeeData || employeeData.length === 0) {
      logger.warn('No employee data provided for name matching');
      return {
        inputName,
        matches: [],
        status: 'notfound'
      };
    }

    // Convert raw employee data to Employee objects
    const employees = employeeData.map((emp) => this.createEmployeeObject(emp));

    // Simple count-based logic: API already did smart matching (alias or name search)
    // If only 1 result → exact match (whether from alias or name search)
    // If multiple results → requires manual selection
    // If no results → not found

    if (employees.length === 0) {
      return {
        inputName,
        matches: [],
        status: 'notfound'
      };
    }

    if (employees.length === 1) {
      // Single result = exact match (API did the smart matching)
      return {
        inputName,
        matches: employees,
        selectedEmployee: employees[0],
        status: 'exact'
      };
    }

    // Multiple results require manual selection
    return {
      inputName,
      matches: employees,
      selectedEmployee: undefined,
      status: 'multiple'
    };
  }
}

export const nameResolver = new NameResolver();
